// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tax-info-card-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.tax-info-card-wrapper .tax-info-tab-wrapper {
  display: flex;
}
.tax-info-card-wrapper .tax-info-tab-wrapper .tcs-tab-wrapper,
.tax-info-card-wrapper .tax-info-tab-wrapper .tds-tab-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  cursor: pointer;
}
.tax-info-card-wrapper .tax-info-tab-wrapper .tcs-tab-wrapper span,
.tax-info-card-wrapper .tax-info-tab-wrapper .tds-tab-wrapper span {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
}
.tax-info-card-wrapper .tax-info-tab-wrapper .tcs-tab-wrapper.active,
.tax-info-card-wrapper .tax-info-tab-wrapper .tds-tab-wrapper.active {
  color: #93288E;
  border-bottom: 1px solid #93288E;
}
.tax-info-card-wrapper .tax-info-tab-wrapper .tcs-tab-wrapper.inactive,
.tax-info-card-wrapper .tax-info-tab-wrapper .tds-tab-wrapper.inactive {
  color: #adadad;
  background: #f6f6f6;
}
.tax-info-card-wrapper .tax-info-body-wrapper {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper label {
  display: flex;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper label input {
  position: absolute;
  left: -9999px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper label input:checked + .label-text:before {
  box-shadow: inset 0 0 0 0.23em #93288E;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper label .label-text {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  color: #7f7f7f;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper label input:checked + .label-text {
  color: #000;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper label .label-text:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 0.85em;
  height: 0.85em;
  border-radius: 50%;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #7a7a7a;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .declaration {
  margin: 0;
  font-size: 16px;
  line-height: 28px;
  font-weight: 500;
  color: #7a7a7a;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .declaration.active {
  color: #000;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .declaration span {
  font-weight: 700;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .notice {
  margin: 0;
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  color: #000;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .notice .black-bold {
  font-size: 17px;
  font-weight: 700;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .notice .orange-bold {
  color: #93288E;
  font-weight: 700;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper {
  padding: 20px;
  border-radius: 8px;
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .top-section-wrapper {
  display: flex;
  gap: 18px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 22px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .view-more-card {
  display: flex;
  gap: 10px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .view-more-card .card-svg {
  margin-top: 6px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .view-more-card .view-more-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .view-more-card .view-more-info .primary-text {
  font-size: 16px;
  font-weight: 700;
  color: #000;
  margin-top: 4px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .view-more-card .view-more-info .secondary-text {
  font-size: 14px;
  font-weight: 500;
  color: #4c4c4c;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-more-body-wrapper .bottom-section-wrapper {
  padding-top: 22px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .travel-expense-wrapper .view-switch {
  font-size: 16px;
  font-weight: 500;
  color: #008CFF;
  text-decoration: underline;
  cursor: pointer;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .heading-text {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 10px;
  border-radius: 8px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper.active,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper.active {
  border: 1px solid #93288E;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper.inactive,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper.inactive {
  background: #f6f6f6;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper label,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper label {
  display: flex;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper label input,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper label input {
  position: absolute;
  left: -9999px;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper label input:checked + .label-text:before,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper label input:checked + .label-text:before {
  box-shadow: inset 0 0 0 0.35em #93288E;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper label .label-text,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper label .label-text {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #000;
}
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .old-regime-radio-wrapper label .label-text:before,
.tax-info-card-wrapper .tax-info-body-wrapper .tax-radio-wrapper .regimes-radio-wrapper .new-regime-radio-wrapper label .label-text:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #f6f6f6;
  width: 1.2em;
  height: 1.2em;
  border-radius: 50%;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em #7a7a7a;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicPaymentPage/components/TaxInfoCard/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;AACR;AACQ;;EAEI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;AACZ;AACY;;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AAEhB;AACY;;EACI,cAAA;EACA,gCAAA;AAEhB;AACY;;EACI,cAAA;EACA,mBAAA;AAEhB;AAGI;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAGQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AADZ;AAGY;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AADhB;AAGgB;EACI,kBAAA;EACA,aAAA;AADpB;AAIgB;EACI,sCAAA;AAFpB;AAKgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHpB;AAMgB;EACI,WAAA;AAJpB;AAOgB;EACI,aAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;AALpB;AASY;EACI,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAPhB;AASgB;EACI,WAAA;AAPpB;AAUgB;EACI,gBAAA;AARpB;AAYY;EACI,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAVhB;AAYgB;EACI,eAAA;EACA,gBAAA;AAVpB;AAagB;EACI,cAAA;EACA,gBAAA;AAXpB;AAeY;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AAbhB;AAegB;EACI,aAAA;EACA,SAAA;EACA,6BAAA;EACA,oBAAA;AAbpB;AAgBgB;EACI,aAAA;EACA,SAAA;AAdpB;AAgBoB;EACI,eAAA;AAdxB;AAiBoB;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAfxB;AAiBwB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAf5B;AAkBwB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAhB5B;AAqBgB;EACI,iBAAA;AAnBpB;AAwBY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;AAtBhB;AA0BQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAxBZ;AA0BY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAxBhB;AA2BY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAzBhB;AA2BgB;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAzBpB;AA2BoB;;EACI,yBAAA;AAxBxB;AA2BoB;;EACI,mBAAA;AAxBxB;AA2BoB;;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAxBxB;AA0BwB;;EACI,kBAAA;EACA,aAAA;AAvB5B;AA0BwB;;EACI,sCAAA;AAvB5B;AA0BwB;;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAvB5B;AA0BwB;;EACI,aAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;AAvB5B","sourcesContent":[".tax-info-card-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n\n    .tax-info-tab-wrapper {\n        display: flex;\n\n        .tcs-tab-wrapper,\n        .tds-tab-wrapper {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 20px 0;\n            cursor: pointer;\n\n            span {\n                text-align: center;\n                font-size: 18px;\n                font-weight: 700;\n            }\n\n            &.active {\n                color: #93288E;\n                border-bottom: 1px solid #93288E;\n            }\n\n            &.inactive {\n                color: #adadad;\n                background: #f6f6f6;\n            }\n        }\n    }\n\n    .tax-info-body-wrapper {\n        padding: 20px;\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n\n        .travel-expense-wrapper {\n            display: flex;\n            flex-direction: column;\n            gap: 20px;\n\n            label {\n                display: flex;\n                position: relative;\n                overflow: hidden;\n                cursor: pointer;\n\n                input {\n                    position: absolute;\n                    left: -9999px;\n                }\n\n                input:checked+.label-text:before {\n                    box-shadow: inset 0 0 0 0.23em #93288E;\n                }\n\n                .label-text {\n                    display: flex;\n                    align-items: center;\n                    gap: 10px;\n                    font-size: 20px;\n                    font-weight: 700;\n                    color: #7f7f7f;\n                }\n\n                input:checked+.label-text {\n                    color: #000;\n                }\n\n                .label-text:before {\n                    display: flex;\n                    flex-shrink: 0;\n                    content: \"\";\n                    background-color: #fff;\n                    width: 0.85em;\n                    height: 0.85em;\n                    border-radius: 50%;\n                    transition: 0.25s ease;\n                    box-shadow: inset 0 0 0 0.1em #7a7a7a;\n                }\n            }\n\n            .declaration {\n                margin: 0;\n                font-size: 16px;\n                line-height: 28px;\n                font-weight: 500;\n                color: #7a7a7a;\n\n                &.active {\n                    color: #000;\n                }\n\n                span {\n                    font-weight: 700;\n                }\n            }\n\n            .notice {\n                margin: 0;\n                font-size: 16px;\n                line-height: 28px;\n                font-weight: 400;\n                color: #000;\n\n                .black-bold {\n                    font-size: 17px;\n                    font-weight: 700;\n                }\n\n                .orange-bold {\n                    color: #93288E;\n                    font-weight: 700;\n                }\n            }\n\n            .view-more-body-wrapper {\n                padding: 20px;\n                border-radius: 8px;\n                background: #fbfbfb;\n                display: flex;\n                flex-direction: column;\n\n                .top-section-wrapper {\n                    display: flex;\n                    gap: 18px;\n                    border-bottom: 1px solid #ddd;\n                    padding-bottom: 22px;\n                }\n\n                .view-more-card {\n                    display: flex;\n                    gap: 10px;\n\n                    .card-svg {\n                        margin-top: 6px;\n                    }\n\n                    .view-more-info {\n                        display: flex;\n                        flex-direction: column;\n                        gap: 10px;\n\n                        .primary-text {\n                            font-size: 16px;\n                            font-weight: 700;\n                            color: #000;\n                            margin-top: 4px;\n                        }\n\n                        .secondary-text {\n                            font-size: 14px;\n                            font-weight: 500;\n                            color: #4c4c4c;\n                        }\n                    }\n                }\n\n                .bottom-section-wrapper {\n                    padding-top: 22px;\n                }\n\n            }\n\n            .view-switch {\n                font-size: 16px;\n                font-weight: 500;\n                color: #008CFF;\n                text-decoration: underline;\n                cursor: pointer;\n            }\n        }\n\n        .tax-radio-wrapper {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 16px;\n\n            .heading-text {\n                font-size: 18px;\n                font-weight: 700;\n                color: #000;\n            }\n\n            .regimes-radio-wrapper {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n                flex-wrap: wrap;\n\n                .old-regime-radio-wrapper,\n                .new-regime-radio-wrapper {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    padding: 14px 10px;\n                    border-radius: 8px;\n\n                    &.active {\n                        border: 1px solid #93288E;\n                    }\n\n                    &.inactive {\n                        background: #f6f6f6;\n                    }\n\n                    label {\n                        display: flex;\n                        position: relative;\n                        overflow: hidden;\n                        cursor: pointer;\n\n                        input {\n                            position: absolute;\n                            left: -9999px;\n                        }\n\n                        input:checked+.label-text:before {\n                            box-shadow: inset 0 0 0 0.35em #93288E;\n                        }\n\n                        .label-text {\n                            display: flex;\n                            align-items: center;\n                            gap: 10px;\n                            font-size: 14px;\n                            font-weight: 700;\n                            color: #000;\n                        }\n\n                        .label-text:before {\n                            display: flex;\n                            flex-shrink: 0;\n                            content: \"\";\n                            background-color: #f6f6f6;\n                            width: 1.2em;\n                            height: 1.2em;\n                            border-radius: 50%;\n                            transition: 0.25s ease;\n                            box-shadow: inset 0 0 0 0.125em #7a7a7a;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
